export default function isEmail(value) {
  return (
    value.match(/^([0-9a-zA-Z]([\-_\.][0-9a-zA-Z]+)*)+@(([0-9a-zA-Z][-\w]*[0-9a-zA-Z]*\.)+[a-zA-Z0-9]{2,17})$/) !== null
  );
}
